<div *nzModalTitle></div>
@if (isLoading()) {
  <korviu-loader></korviu-loader>
}
<div class="flex flex-col gap-4 md:gap-6 items-center text-center">
  <i nz-icon>
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
      <mask
        id="mask0_5975_285075"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="41"
        height="40"
      >
        <rect x="0.5" width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5975_285075)">
        <path
          d="M21.3346 28.3335C21.8069 28.3335 22.2027 28.1738 22.5221 27.8543C22.8416 27.5349 23.0013 27.1391 23.0013 26.6668C23.0013 26.1946 22.8416 25.7988 22.5221 25.4793C22.2027 25.1599 21.8069 25.0002 21.3346 25.0002C20.8624 25.0002 20.4666 25.1599 20.1471 25.4793C19.8277 25.7988 19.668 26.1946 19.668 26.6668C19.668 27.1391 19.8277 27.5349 20.1471 27.8543C20.4666 28.1738 20.8624 28.3335 21.3346 28.3335ZM19.668 21.6668H23.0013V11.6668H19.668V21.6668ZM21.3346 36.6668C19.0291 36.6668 16.8624 36.2293 14.8346 35.3543C12.8069 34.4793 11.043 33.2918 9.54297 31.7918C8.04297 30.2918 6.85547 28.5279 5.98047 26.5002C5.10547 24.4724 4.66797 22.3057 4.66797 20.0002C4.66797 17.6946 5.10547 15.5279 5.98047 13.5002C6.85547 11.4724 8.04297 9.7085 9.54297 8.2085C11.043 6.7085 12.8069 5.521 14.8346 4.646C16.8624 3.771 19.0291 3.3335 21.3346 3.3335C23.6402 3.3335 25.8069 3.771 27.8346 4.646C29.8624 5.521 31.6263 6.7085 33.1263 8.2085C34.6263 9.7085 35.8138 11.4724 36.6888 13.5002C37.5638 15.5279 38.0013 17.6946 38.0013 20.0002C38.0013 22.3057 37.5638 24.4724 36.6888 26.5002C35.8138 28.5279 34.6263 30.2918 33.1263 31.7918C31.6263 33.2918 29.8624 34.4793 27.8346 35.3543C25.8069 36.2293 23.6402 36.6668 21.3346 36.6668Z"
          fill="#F28334"
        />
      </g>
    </svg>
  </i>
  <h1>{{ 'profile.removePaymentAccount' | translate }}</h1>
  @if (modalData.isDefault) {
    <span>{{ 'profile.areYouSureYouWantToDeleteDefault' | translate }}</span>
  } @else {
    <span>{{ 'profile.areYouSureYouWantToDelete' | translate }}</span>
  }
</div>
<div *nzModalFooter>
  <div class="flex flex-row gap-2 md:gap-4">
    <korviu-button class="flex-1" color="ghost" (onclick)="onCancelClick()">
      {{ 'common.cancel' | translate }}
    </korviu-button>
    <korviu-button class="flex-1" color="tertiary" (onclick)="onRemoveClick()">
      {{ 'profile.remove' | translate }}
    </korviu-button>
  </div>
</div>
